import http from 'utils/http';
import { CreateTaggingsPayload, TagContexts, TagContextsResponse, TaggedRecordsResponse } from './types';
import { getTaggingContextsUrl, getTaggingsUrl, getTaggingUrl } from './apiUrls';

export function getTaggedRecords(params?: Record<string, unknown>): Promise<TaggedRecordsResponse> {
  return http.get(getTaggingsUrl(), params);
}

export function getTaggingContexts(): Promise<TagContexts> {
  return http.get(getTaggingContextsUrl()).then((response: TagContextsResponse) => response.data);
}

export function createTaggings(payload: CreateTaggingsPayload): Promise<{ meta: { message: string } }> {
  return http.post(getTaggingsUrl(), payload);
}

export function destroyTagging(id: number): Promise<{ meta: { message: string } }> {
  return http.delete(getTaggingUrl(id), undefined, { skipConfirm: true });
}
